import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { RecpatchaService } from './recaptcha.service';

angular.module('app-lite.recaptcha', [])
.factory('recaptchaApi', downgradeInjectable(RecpatchaService));
